module.exports = __webpack_public_path__ + "media/images/amenities_icons/accelerator_programs-a6cbaa89324b654e96988cf8cc5719fd.svg";